export const User = (api) => ({
  me() {
    return api.get('/v1/me')
  },
  logout() {
    return api.post('/v1/logout')
  },
  login(params) {
    return api.post('/v1/login', params)
  }
})
